import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BladApi, KodBleduApi } from '../../shared/models/kody-bledow-api.model';

@Injectable({
  providedIn: 'root',
})
export class KodyBledowApiService {

  domyslnyKodBledu = 0;

  constructor() { }

  get(error: HttpErrorResponse): BladApi {
    const kod: number = Number(error?.headers?.get('X-Error-Code')) || this.domyslnyKodBledu;
    return KodBleduApi.get(kod) || KodBleduApi.get(this.domyslnyKodBledu);
  }

}
